<template>
	<v-app>
		<!-- <v-toolbar app>
			<v-toolbar-title class="headline text-uppercase">
				<span>Vuetify</span>
				<span class="font-weight-light">MATERIAL DESIGN</span>
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn flat href="https://github.com/vuetifyjs/vuetify/releases/latest" target="_blank">
				<span class="mr-2">Latest Release</span>
			</v-btn>
		</v-toolbar>

		<v-content>
			<HelloWorld />
		</v-content> -->
		<div class="text-xs-center mt-5" v-if="!isChecked">
			<v-progress-circular :size="100" :width="15" color="primary" indeterminate></v-progress-circular>
		</div>
		<ControllerLogin v-if="isChecked && !isLogged" v-on:checkLogin="checkLogin()" />
		<ControllerContent v-if="isChecked && isLogged" />


	</v-app>
</template>

<script>
	import ControllerLogin from './controllers/ControllerLogin'
	import ControllerContent from './controllers/ControllerContent'

	export default {
		name: 'AppMain',
		components: {
			ControllerLogin,
			ControllerContent
		},
		data: () => ({
			isChecked: false,
			isLogged: false,
		}),
		mounted() {
			this.checkLogin();
			setInterval(() => {
				this.checkLogin();
			},10000);
		},
		
		methods: {
			checkLogin() {
				this.$http.get(process.env.VUE_APP_API_URL + "/auth/check", {
					params: {}
				}).then(response => {
					console.log(response.body)
					this.isChecked = true;
					this.isLogged = response.body.isLogged;
					if (this.isLogged) {
						// this.$store.dispatch('user', response.body.user)
						if(JSON.stringify(response.body.user) != JSON.stringify(this.$store.state.signedUser)){
							this.$store.state.signedUser = response.body.user;
						}
						
					}

				})
			}
		}
	}
</script>